<table style="width:100%">
  <thead>
  <th *ngFor="let column of listColumns"
      (click)="onHeaderClicked(column.id)">
    {{column.title| titlecase}}
    <fa-icon *ngIf="isColumnInAscendingOrder(column.id)"
             [icon]="faAngleUp"></fa-icon>
    <fa-icon *ngIf="isColumnInDescendingOrder(column.id)"
             [icon]="faAngleDown"></fa-icon>


  </th>
  </thead>

  <tr *ngFor="let entity of entities"
      [class.selected]="entity === selectedEntity"
      (click)="onSelect(entity)"
      (dblclick)="onSelect(entity); rowDoubleClicked(entity)">
    <th *ngFor="let column of listColumns">{{entity[column.id]}}</th>

  </tr>
</table>
